import { memo } from "react";
import { Text, View, Page, Document, PDFViewer } from "@react-pdf/renderer";
import styles from "../pdf/Styles.js";
import "../pdf/Fonts.js";
import { Box, Button } from "@mui/material"

const OwnersPopulationDetailsSummaryPdf = ({
    data,
    selectedOwner,
    lastUpdatedDate,
    organization,
    setStep,
}) => {
    if (!data || !selectedOwner) return null;

    return (
        <>
            <PDFViewer style={{ width: "85vw", height: "100vh" }}>
                <Document>
                    <Page size="A3" style={styles.page} wrap>
                        <View style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 20,
                            padding: 10,
                            borderRadius: 8,
                            width: '100%',
                        }}>
                            {/* Organization Name on the left half */}
                            <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={{
                                    fontSize: 12,
                                    fontWeight: 'normal',
                                    textAlign: 'center',
                                    flexWrap: 'wrap', // Allow wrapping if needed
                                }}>
                                    {organization?.name}
                                </Text>
                            </View>

                            {/* Actual Title on the right half */}
                            <View style={{ flex: 1, justifyContent: 'center' }}>
                                <Text style={{
                                    fontSize: 16,
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                }}>
                                    Στοιχεία Πληθυσμού
                                </Text>
                            </View>
                        </View>


                        <View style={{
                            backgroundColor: '#f0f0f0',
                            padding: 10,
                            borderRadius: 8,
                            marginBottom: 20
                        }}>
                            <Text style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 10 }}>Στοιχεία Μονάδας</Text>
                            <View>
                                <Text style={{ fontSize: 12, marginBottom: 5 }}>{`Κωδικός Εκτροφής: ${selectedOwner.code}`}</Text>
                                <Text style={{ fontSize: 12, marginBottom: 5 }}>{`Όνομα Παραγωγού: ${selectedOwner.lastName} ${selectedOwner.firstName}`}</Text>
                                <Text style={{ fontSize: 12, marginBottom: 5 }}>{`Διεύθυνση Εκτροφής: ${selectedOwner.address}`}</Text>
                                <Text style={{ fontSize: 12, marginBottom: 5 }}>{`Νομός Εκτροφής: ${selectedOwner.county}`}</Text>
                            </View>
                        </View>

                        <View style={styles.section}>
                            <Text style={{ fontSize: 14, display: "flex", justifyContent: "center", alignSelf: "center", marginBottom: 7 }}>Στοιχεία Απογραφής</Text>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <View style={{ width: '48%' }}>
                                    {[
                                        { label: "Δυναμικό Εκτροφής", value: data.maleAliveAnimals + data.femaleAliveAnimals },
                                        { label: "Καταγεγραμμένα στην Εκτροφή", value: data.registeredInFlock },
                                        { label: "Αρσενικά ζώα", value: data.maleAliveAnimals },
                                        { label: "Θηλυκά ζώα", value: data.femaleAliveAnimals },
                                        { label: "Ζυγούρια", value: data.animalsNeverLambed },
                                        { label: "Στέρφα", value: data.animalsLambedBeforeButNotInPeriod },
                                        { label: "Ηλικία > 12 μήνες", value: data.age12Months },
                                        { label: "Ηλικία > 14 μήνες", value: data.age14Months },
                                        { label: "Σε γαλ/γη", value: data.animalsLambedInPeriod },
                                        { label: "1η γαλακτική περίοδο", value: data.lambingCategories.firstLambing.length },
                                        { label: "2η γαλακτική περίοδο", value: data.lambingCategories.secondLambing.length },
                                        { label: "3η γαλακτική περίοδο", value: data.lambingCategories.thirdLambing.length },
                                        { label: "4η γαλακτική περίοδο", value: data.lambingCategories.fourthLambing.length },
                                        { label: "5η και άνω γαλακτική περίοδο", value: data.lambingCategories.fifthOrMoreLambing.length },
                                    ].map((row, index) => (
                                        <View style={styles.tableRow} key={index}>
                                            <Text style={styles.tableCell}>{row.label}</Text>
                                            <Text style={styles.tableCell}>{row.value}</Text>
                                        </View>
                                    ))}
                                    <View style={{ marginTop: 15, alignItems: "center", width: "100%" }}>
                                        <Text style={{ fontWeight: "bold", fontSize: 16 }}>
                                            Ημερομηνία Τελευταίας Ενημέρωσης: {new Date(lastUpdatedDate).toLocaleDateString("el-GR")}
                                        </Text>
                                    </View>


                                </View>

                                <View style={{ width: '48%' }}>
                                    {[
                                        { label: "Αμνοί", value: data.aliveLambs },
                                        { label: "Αρσενικά ζωντανά", value: data.maleAliveLambs },
                                        { label: "Αρσενικά νεκρά", value: data.maleDeadLambs },
                                        { label: "Θηλυκά ζωντανά", value: data.femaleAliveLambs },
                                        { label: "Θηλυκά νεκρά", value: data.femaleDeadLambs },
                                    ].map((row, index) => (
                                        <View style={styles.tableRow} key={index}>
                                            <Text style={styles.tableCell}>{row.label}</Text>
                                            <Text style={styles.tableCell}>{row.value}</Text>
                                        </View>
                                    ))}
                                </View>
                            </View>
                        </View>
                    </Page>
                </Document>
            </PDFViewer >
            {/* Back Button */}
            <Box sx={{ width: "100%", marginBottom: 3, display: "flex", justifyContent: "center" }}>
                <Button variant="outlined" color="secondary" onClick={() => setStep(2)}>
                    Πίσω
                </Button>
            </Box>
        </>
    );
};

export default memo(OwnersPopulationDetailsSummaryPdf);
